export default __webpack_public_path__ + "static/media/box-container-flipped.bfa77a4d.png";